export enum ProfileStatus {
  STORE_PREFERENCE,
  STORE_NAME,
  STORE_MEDIA,
  STORE_DOCUMENTATION,
  STORE_BILLING_DETAILS,
  STORE_BANK_DETAILS,
  STORE_PRODUCT,
}

export const ProfileStatusText = {
  [ProfileStatus.STORE_PREFERENCE]: 'Store preferences',
  [ProfileStatus.STORE_NAME]: 'Store Name',
  [ProfileStatus.STORE_MEDIA]: 'Media',
  [ProfileStatus.STORE_DOCUMENTATION]: 'Documentation',
  [ProfileStatus.STORE_BILLING_DETAILS]: 'Billing Details',
  [ProfileStatus.STORE_BANK_DETAILS]: 'Bank Details',
  [ProfileStatus.STORE_PRODUCT]: 'Product',
}
